import { jsx as _jsx } from "react/jsx-runtime";
import { flattenError } from './flattenError';
/** Renders errors that are a plain, boring string. */
export const ErrorContentFromString = ({ error }) => {
    const message = flattenError(error);
    if (!message)
        return null;
    return _jsx("p", { children: flattenError(error) });
};
